module.exports = __webpack_public_path__ + "res/img_listening.02c87d9a527221b3616386e74503ada1.gif";